import React from "react";
import { BackIcon, BucketIcon, UserIconTwo } from "../Icons";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useQuery } from "react-query";
import BankIcon from "mdi-react/BankIcon";

export default function EBCompaniesWrapper({ Nav }) {
  // const triggerRefetch = useCallback(() => {
  //   refetch();
  // }, []);
  const { backendUrl, token } = useAuth();
  const fetchInvexPartnerStats = async () => {
    const res = await fetch(`${backendUrl}/api/partnership/invexerp-partners`, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    const data = await res.json();

    return data;
  };

  const { data, isFetching, isError, refetch } = useQuery(
    ["GET_INVEX_PARTNERS"],
    () => fetchInvexPartnerStats(),
    {
      enabled: true,
      keepPreviousData: false,
    }
  );

  return (
    <main className="invoice-wrapper">
      <section className=" stats mb-3">
        <div className="stat" style={{ borderLeft: "7px solid #2463ae" }}>
          <div className="icon bg-light-blue text-primary">
            <UserIconTwo />
          </div>
          <div className="details">
            <p>{data?.length || 0}</p>
            <span>Total Partners</span>
          </div>
        </div>
        <div className="stat" style={{ borderLeft: "7px solid green" }}>
          <div className="icon bg-light-blue">
            <UserIconTwo fill="green" />
          </div>
          <div className="details">
            <p>
              {(!isError &&
                (Array.isArray(data)
                  ? data.filter((ele) => ele.is_verified).length
                  : 0)) ||
                0}
            </p>
            <span>Total verified</span>
          </div>
        </div>
        <div className="stat" style={{ borderLeft: "7px solid orange" }}>
          <div className="icon bg-light-blue">
            <UserIconTwo fill="orange" />
          </div>
          <div className="details">
            <p>
              {(!isError &&
                (Array.isArray(data)
                  ? data.filter((ele) => !ele.is_verified).length
                  : 0)) ||
                0}
            </p>
            <span>Total unverified</span>
          </div>
        </div>
      </section>

      {Nav && <div className="nav-bar">{Nav}</div>}
      <Outlet context={{ refetch }} />
    </main>
  );
}
